import { IonActionSheet, IonIcon, IonSpinner } from '@ionic/react'
import { ChargingLocation } from '@vae/server/src/interfaces/eNode/eNode.interface'
import { closeOutline, ellipsisVertical, home, locationOutline, trash } from 'ionicons/icons'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../../../analytics/utils/firebaseUtils'
import Button from '../../../../components/actions/Button'
import PageWrapper from '../../../../wrappers/pageWrapper/PageWrapper'
import AddChargingStation from '../addChargingStation/AddChargingStation'
import { useChargingLocations } from './useChargingLocations'

const ChargingLocations: FC = () => {
	const [addingStation, setAddingStation] = useState(false)
	const { t: t } = useTranslation('pages_electricCar', { keyPrefix: 'chargingLocations' })
	const { t: tc } = useTranslation('common')
	const [selectedLocation, setSelectedLocation] = useState<ChargingLocation | null>(null)

	const {
		object,
		chargingLocations,
		isLoading,
		vehicles,
		vehiclesLoading,
		invalidateChargingStations,
		deleteChargingLocation,
		updateObjectChargingLocation,
	} = useChargingLocations()

	const handleSave = () => {
		setAddingStation(false)
		invalidateChargingStations()
	}

	if (addingStation)
		return (
			<AddChargingStation
				vehiclesLoading={vehiclesLoading}
				vehicles={vehicles ?? []}
				goForward={handleSave}
			/>
		)

	const isSelectedLocation = object.chargingLocationId === selectedLocation?.id

	return (
		<PageWrapper page='chargingLocations' appBarOptions={{ navigationType: 'back' }}>
			<div className='description text-text-grey-200 dark:text-text-grey-100'>{t('kuvaus')}</div>
			{isLoading && (
				<IonSpinner className='text-brand-primary-100-light dark:text-brand-primary-100-dark' />
			)}
			<div className='locations-container'>
				{chargingLocations &&
					chargingLocations.map(location => {
						const isSelected = object.chargingLocationId === location.id
						return (
							<div key={location.id} className={isSelected ? 'charge-location' : 'charge-location'}>
								<div className='bg-brand-secondary-200-light dark:bg-brand-secondary-100-dark flex justify-center rounded-lg p-2 w-12 h-12'>
									<IonIcon
										className='location-icon text-brand-primary-100-light dark:text-brand-primary-100-dark'
										icon={locationOutline}
									/>
								</div>
								<div className='text'>
									<div className='name tracking-wide text-text-dark dark:text-white'>
										{location.name}
									</div>
									<div className='coords text-lg text-text-grey-200 dark:text-text-grey-100'>
										{isSelected && <div>{t('locationIsVisibleInConsumption')}</div>}
										{/* {location.latitude} {location.longitude} */}
									</div>
								</div>
								<IonIcon
									className='text-text-grey-200 dark:text-text-grey-100'
									onClick={() => setSelectedLocation(location)}
									icon={ellipsisVertical}
								/>
							</div>
						)
					})}
			</div>

			<Button onClick={() => setAddingStation(true)}>{t('lisaa')}</Button>

			<IonActionSheet
				isOpen={Boolean(selectedLocation)}
				onDidDismiss={() => setSelectedLocation(null)}
				buttons={[
					{
						text: isSelectedLocation ? t('disconnect') : t('setLocationIsVisible'),
						icon: home,
						handler: () => {
							logEvent(
								isSelectedLocation
									? 'click-ev-disconnect-charging-location'
									: 'click-ev-connect-charging-location'
							)

							if (!selectedLocation) return null

							const isSelected = object.chargingLocationId === selectedLocation.id
							updateObjectChargingLocation(isSelected ? null : selectedLocation.id)
						},
					},
					{
						text: t('delete'),
						icon: trash,
						handler: () => {
							logEvent('click-ev-delete-charging-location')
							if (selectedLocation) {
								deleteChargingLocation(selectedLocation.id)
							}
						},
					},
					{
						text: tc('peruuta'),
						role: 'cancel',
						icon: closeOutline,
						handler: () => {
							logEvent('click-ev-cancel-charging-location')
							setSelectedLocation(null)
						},
					},
				]}
			/>
		</PageWrapper>
	)
}
export default ChargingLocations
